"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _service = require("@insided/destination/modules/Content/TopicList/service");

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IdeaStatusDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeaStatusDropdown, _Component);

  var _super = _createSuper(IdeaStatusDropdown);

  function IdeaStatusDropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, IdeaStatusDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "searchInputRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false,
      searchValue: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleStatusToggle", function (statusId, checked) {
      var onChange = _this.props.onChange;
      var ideaStatusList = _this.state.ideaStatusList;
      var status = ideaStatusList === null || ideaStatusList === void 0 ? void 0 : ideaStatusList.find(function (s) {
        return String(s.id) === String(statusId);
      });
      if (!status) return;
      var newSelectedStatuses = checked ? [].concat((0, _toConsumableArray2.default)(_this.selectedStatuses), [status.name]) : _this.selectedStatuses.filter(function (s) {
        return s !== status.name;
      });
      onChange === null || onChange === void 0 ? void 0 : onChange(newSelectedStatuses);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeSelectedStatus", function (statusName) {
      var onChange = _this.props.onChange;

      var newSelectedStatuses = _this.selectedStatuses.filter(function (s) {
        return s !== statusName;
      });

      onChange === null || onChange === void 0 ? void 0 : onChange(newSelectedStatuses);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDropdownToggle", function () {
      _this.setState(function (_ref) {
        var isOpen = _ref.isOpen;
        return {
          isOpen: !isOpen
        };
      }, function () {
        return requestAnimationFrame(function () {
          var _this$searchInputRef$;

          return (_this$searchInputRef$ = _this.searchInputRef.current) === null || _this$searchInputRef$ === void 0 ? void 0 : _this$searchInputRef$.focus({
            preventScroll: true
          });
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSelectedItem", function (statusName) {
      return (0, _preact.h)("div", {
        key: statusName,
        className: "idea-status-selected-item"
      }, (0, _preact.h)("div", {
        className: "idea-status-selected-item-name"
      }, statusName), (0, _preact.h)("div", {
        className: "idea-status-selected-remove-button",
        onClick: function onClick(e) {
          e.stopPropagation();

          _this.removeSelectedStatus(statusName);
        },
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();

            _this.removeSelectedStatus(statusName);
          }
        }
      }, (0, _preact.h)(_assets.default, {
        icon: "close",
        width: 16,
        height: 16,
        color: "currentColor"
      })));
    });
    return _this;
  }

  (0, _createClass2.default)(IdeaStatusDropdown, [{
    key: "selectedStatuses",
    get: function get() {
      var _this$props$value;

      return (_this$props$value = this.props.value) !== null && _this$props$value !== void 0 ? _this$props$value : [];
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var ideaStatusList;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _service.getIdeaStatuses)();

              case 2:
                ideaStatusList = _context.sent;

                if (ideaStatusList.length) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                this.setState({
                  ideaStatusList: ideaStatusList
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "getNestedItems",
    value: function getNestedItems() {
      var _filteredList$map;

      var _this$state = this.state,
          ideaStatusList = _this$state.ideaStatusList,
          searchValue = _this$state.searchValue;
      var filteredList = searchValue ? ideaStatusList === null || ideaStatusList === void 0 ? void 0 : ideaStatusList.filter(function (status) {
        return status.name.toLowerCase().includes(searchValue.toLowerCase());
      }) : ideaStatusList;
      return (_filteredList$map = filteredList === null || filteredList === void 0 ? void 0 : filteredList.map(function (status) {
        return {
          id: String(status.id),
          title: status.name,
          children: []
        };
      })) !== null && _filteredList$map !== void 0 ? _filteredList$map : [];
    }
  }, {
    key: "getSelectedItemIds",
    value: function getSelectedItemIds() {
      var _ideaStatusList$filte;

      var ideaStatusList = this.state.ideaStatusList;
      var selectedStatuses = this.selectedStatuses;
      return (_ideaStatusList$filte = ideaStatusList === null || ideaStatusList === void 0 ? void 0 : ideaStatusList.filter(function (status) {
        return selectedStatuses.includes(status.name);
      }).map(function (status) {
        return String(status.id);
      })) !== null && _ideaStatusList$filte !== void 0 ? _ideaStatusList$filte : [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var placeholderProp = this.props.placeholder;
      var _this$state2 = this.state,
          isOpen = _this$state2.isOpen,
          searchValue = _this$state2.searchValue;
      var selectedStatuses = this.selectedStatuses;
      var placeholder = placeholderProp !== null && placeholderProp !== void 0 ? placeholderProp : 'Select status';
      return (0, _preact.h)("div", {
        className: "idea-status-dropdown"
      }, (0, _preact.h)(_dropdown.default, {
        popupName: "idea-status-dropdown",
        className: "dropdown-selector",
        triggerElement: "div",
        trigger: selectedStatuses.length === 0 ? (0, _preact.h)(_Button.default, {
          title: placeholder,
          endIcon: isOpen ? (0, _preact.h)(_ChevronUp.default, {
            width: 16,
            height: 16
          }) : (0, _preact.h)(_ChevronDown.default, {
            width: 16,
            height: 16
          }),
          onClick: this.onDropdownToggle,
          size: "medium",
          fullWidth: true,
          "data-qa": "select-status"
        }) : (0, _preact.h)("div", {
          className: "select-idea-status",
          onClick: this.onDropdownToggle,
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              _this2.onDropdownToggle();
            }
          },
          role: "button",
          tabIndex: 0
        }, (0, _preact.h)("div", {
          className: "idea-status-selector-wrapper"
        }, selectedStatuses.map(function (statusName) {
          return _this2.renderSelectedItem(statusName);
        })), (0, _preact.h)("div", {
          className: "idea-status-selector-icon"
        }, isOpen ? (0, _preact.h)(_ChevronUp.default, {
          width: 16,
          height: 16
        }) : (0, _preact.h)(_ChevronDown.default, {
          width: 16,
          height: 16
        }))),
        triggerClass: "dropdown-selector-wrapper--control"
      }, (0, _preact.h)("div", {
        className: "idea-status-dropdown-options-container"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        searchInputRef: this.searchInputRef,
        placeholder: "Search",
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.setState({
            searchValue: e.target.value
          });
        },
        onClear: function onClear() {
          return _this2.setState({
            searchValue: ''
          });
        }
      }), (0, _preact.h)(_NestedDropdown.default, {
        labelId: "idea-status-selector",
        items: this.getNestedItems(),
        selectedItems: this.getSelectedItemIds(),
        onMultiSelect: this.handleStatusToggle,
        depth: 1
      }))));
    }
  }]);
  return IdeaStatusDropdown;
}(_preact.Component);

var _default = IdeaStatusDropdown;
exports.default = _default;